/**
 * Normaliza la respuesta de la API para asegurar un formato consistente
 * @param {Object} response - Respuesta de la API
 * @returns {Object} Respuesta normalizada con results siempre como array
 */
export const normalizeApiResponse = (response) => {
  if (!response) return { results: [] };

  // Si ya tiene estructura de paginación, retornarla
  if (response.results && Array.isArray(response.results)) {
    return response;
  }

  // Si es un array directo, convertirlo a formato paginado
  if (Array.isArray(response)) {
    return {
      count: response.length,
      next: null,
      previous: null,
      results: response
    };
  }

  // Si es un objeto simple, convertirlo a formato paginado
  return {
    count: 1,
    next: null,
    previous: null,
    results: [response]
  };
};